























































import {Component, Vue, Ref} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {notifyError} from "@/utils/notify-helper";
import EmailDistribution from "@/pages/Pages/Email/EmailDistribution.vue";
import SmsDistribution from "@/pages/Pages/SMS/SmsDistribution.vue";
import PushDistribution from "@/pages/Pages/Push/PushDistribution.vue";
import ViberDistribution from "@/pages/Pages/Viber/ViberDistribution.vue";
import WhatsAppDistribution from "@/pages/Pages/Whatsapp/WhatsAppDistribution.vue";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import CustomDistribution from "@/pages/Pages/Custom/CustomDistribution.vue";

@Component({ components: {
    CustomDistribution,
    WhatsAppDistribution, ViberDistribution, PushDistribution, EmailDistribution, SmsDistribution} })
export default class ModerationDistribution extends Vue {
  @Ref('validator') validator: any;
  @Action("allowBulkDistr") actionAllowDistribution: any;
  @Action("denyBulkDistr") actionDenyDistribution: any;
  @Action("onModerateBulkDistr") actionOnModerateDistribution: any;
  @Action("actionLog") actionLog: any;

  templateStatus: string = "";
  reason: string = "";
  showDialog: boolean = false;
  private logObject: ActionLog = {};
  private addititional_info = {};

  onLoadDistribution(template: any) {
    this.templateStatus = template.status;
    this.addititional_info = {
      channel: this.$route.params.channel,
      id: this.$route.params.id,
      reason: this.reason
    }
  }

  back(): void {
    this.$router.push('/user_management/distributions_moderation/');
  }

  allowTemplate(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Moderation",
          action_status: "success",
          object_type: "Distribution",
          addititional_info: getTranslatedParams({...this.addititional_info, ...{status: "Разрешена / Approved"}})
        }
        await this.actionAllowDistribution(this.$route.params.id);
        await this.actionLog(this.logObject);
        resolve();
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        reject();
        notifyError(error);
      }
    })
  }

  denyTemplate(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        let valid: boolean = await this.validator.validate();
        if (valid) {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: "Moderation",
            action_status: "success",
            object_type: "Distribution",
            addititional_info: getTranslatedParams({...this.addititional_info,...{status: "Запрещена / Denied"}})
          }
          await this.actionDenyDistribution({id: this.$route.params.id, description: this.reason});
          await this.actionLog(this.logObject);
          this.showDialog = false;
          resolve();
          this.back();
        } else {
          setTimeout(() => {
            notifyError(null, this.validator.errors);
          }, 100);
        }
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        reject();
        notifyError(error);
      }
    });
  }

  // onModerateTemplate(): Promise<void> {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       await this.actionOnModerateDistribution(this.$route.params.id)
  //       resolve();
  //       document.location.reload();
  //     } catch (error) {
  //       reject();
  //       notifyError(error);
  //     }
  //   });
  // }
}
